<!--suppress ALL -->

<template>
    <v-data-table :items="leaderboard" v-if="leaderboard.length > 0" :items-per-page="15"
                  :headers="dt.leaderboard.headers" :disable-pagination="disablePagination"
                  :hide-default-footer="hideDefaultFooter">

        <template v-slot:header.playersKilled="{ }">
            (PvP)
            <v-icon color="red darken-3">mdi-target</v-icon>
            /
            <v-icon color="red darken-3">mdi-grave-stone</v-icon>
            /
            KD/R
        </template>

        <template v-slot:header.scientistsKilled="{ }">
            (PvE)
            <v-avatar size="28">
                <v-img src="@/assets/hazmatsuit.png" height="28" width="28"/>
            </v-avatar>
            /
            <v-avatar size="28">
                <v-img src="@/assets/hat.wolf.png" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:header.gatheredTotal="{ }">
            <v-avatar size="28">
                <v-img src="@/assets/wood.png" height="28" width="28"/>
            </v-avatar>
            <v-avatar size="28">
                <v-img src="@/assets/stones.png" height="28" width="28"/>
            </v-avatar>
            <v-avatar size="28">
                <v-img src="@/assets/metal.ore.png" height="28" width="28"/>
            </v-avatar>
            <v-avatar size="28">
                <v-img src="@/assets/sulfur.ore.png" height="28" width="28"/>
            </v-avatar>
            <v-avatar size="28">
                <v-img src="@/assets/cloth.png" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:header.soldItems="{ }">
            <v-avatar size="28">
                <v-img src="@/assets/vending.machine.png" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:header.lockedCratesHacked="{ }">
            <v-avatar size="28" tile>
                <v-img src="@/assets/locked_crate.png" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:header.damageReceivedFromEnvironment="{ }">
            <v-icon color="grey lighten-3" left>mdi-snowflake</v-icon>
            <v-icon color="yellow" left>mdi-radioactive</v-icon>
            <v-icon color="red darken-4">mdi-weather-sunny-alert</v-icon>
        </template>

        <template v-slot:header.patrolHelicoptersDestroyed="{ }">
            <v-icon color="grey darken-3">mdi-helicopter</v-icon>
        </template>

        <template v-slot:header.bradleysDestroyed="{ }">
            <v-icon color="red darken-3">mdi-tank</v-icon>
        </template>

        <template v-slot:header.cards="{ }">
            <v-avatar size="28">
                <v-img src="@/assets/keycard_green.png" height="28" width="28"/>
            </v-avatar>
            /
            <v-avatar size="28">
                <v-img src="@/assets/keycard_blue.png" height="28" width="28"/>
            </v-avatar>
            /
            <v-avatar size="28">
                <v-img src="@/assets/keycard_red.png" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:item.playersKilled="{ item }">
            {{ item.playersKilled }} /
            {{ item.pvpDeaths }} /
            {{ (item.playersKilled / Math.max(item.pvpDeaths, 1)).toFixed(2) }}
        </template>

        <template v-slot:item.scientistsKilled="{ item }">
            {{ item.scientistsKilled }} /
            {{ item.animalsKilled }}
        </template>

        <template v-slot:item.cards="{ item }">
            {{ item.greenCardsSwiped }} / {{ item.blueCardsSwiped }} / {{ item.redCardsSwiped }}
        </template>

        <template v-slot:item.damageDealtToPlayers="{ item }">
            {{ item.damageDealtToPlayers }} {{ item.longestDistanceShot }}m
            /
            {{ item.damageDealt - item.damageDealtToPlayers }} {{ item.longestDistanceShotPve }}m

            <v-avatar size="28" tile class="ml-2" v-if="item.mostUsedWeapon">
                <v-img :src="require('../assets/' + item.mostUsedWeapon + '.png')" height="28" width="28"/>
            </v-avatar>
        </template>

        <template v-slot:item.damageReceivedFromPlayers="{ item }">
            {{ item.damageReceivedFromPlayers }} ({{ Math.floor(item.damageReceived) }})
        </template>

        <template v-slot:item.userId="{ item }">
            <div v-if="item.steamUser">
                <v-avatar size="28" class="mr-3">
                    <v-img :src="item.steamUser.profilePictureUrl" width="28" height="28"/>
                </v-avatar>
                <a :href="'http://steamcommunity.com/profiles/' + item.userId" target="_blank">{{
                        item.steamUser.name
                    }}</a>
            </div>
            <a v-else :href="'http://steamcommunity.com/profiles/' + item.userId" target="_blank">{{
                    item.userId
                }}</a>
        </template>

        <template v-slot:item.rank="{ item }">
            <v-icon :title="item.points" color="#FFD700" v-if="item.rank === 1">mdi-crown</v-icon>
            <v-icon :title="item.points" color="#C0C0C0" v-else-if="item.rank === 2">mdi-crown</v-icon>
            <v-icon :title="item.points" color="#cd7f32" v-else-if="item.rank === 3">mdi-medal-outline</v-icon>
            <span :title="item.points" v-else>{{ item.rank }}</span>
        </template>
    </v-data-table>
</template>

<script>
export default {
    props: {
        leaderboard: {
            type: Array,
        },
        disabledColumns: {
            type: Array
        },
        disablePagination: {
            type: Boolean
        },
        hideDefaultFooter: {
            type: Boolean
        }
    },
    data: () => ({
        dt: {
            leaderboard: {
                headers: [
                    {value: 'rank', text: 'Rank'},
                    {value: 'userId', text: 'Player'},
                    {value: 'playersKilled', text: 'PvP Stats'},
                    {value: 'gatheredTotal', text: 'Gathered'},
                    {value: 'soldItems', text: 'Sold items'},
                    {value: 'lockedCratesHacked', text: 'Locked crates hacked'},
                    {value: 'cards', text: 'Card Swipes'},
                    {value: 'damageDealtToPlayers', text: 'Damage dealt'},
                    {value: 'damageReceivedFromPlayers', text: 'Damage received'},
                    {value: 'damageReceivedFromEnvironment', text: 'Damage received (Environment)'},
                    {value: 'patrolHelicoptersDestroyed', text: 'Patrol Helicopters destroyed'},
                    {value: 'bradleysDestroyed', text: 'Bradleys destroyed'},
                ]
            }
        }
    }),
    mounted() {
        this.disabledColumns?.forEach(r => {
            this.dt.leaderboard.headers = this.dt.leaderboard.headers.filter(value => value.value !== r);
        })
    }
}
</script>